
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getDurations = (sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.get(`${Environment.apiUrl}/Admin/GetDurations`, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

const saveDurations = (durations, sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.put(`${Environment.apiUrl}/Admin/UpdateDurations`, durations, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

// Re-renders the Confirmation of Sale PDF for an existing AuctionSaleSummary
// from its CURRENT persisted column values, overwriting the previous PDF at
// the same blob URL (filename is keyed on VIN + language).
const regenerateConfirmationOfSale = (auctionSaleSummaryId, sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.post(`${Environment.apiUrl}/Admin/RegenerateConfirmationOfSale`, { AuctionSaleSummaryId: auctionSaleSummaryId }, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

const AdministrationService =
{
    getDurations,
    saveDurations,
    regenerateConfirmationOfSale,
}

export default AdministrationService
